import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModalService } from '@common/components/modal/modal.service';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { environment } from '@src/environments/environment';
import { AppService } from '@src/suite/app.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class JwtIncerceptor implements HttpInterceptor {
    constructor(
        private appService: AppService,
        private nomWebServicesJson: NomWebServicesJson,
        private modalService: ModalService
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        try {
            return next.handle(this.addAuthHeader(request)).pipe(
                map(r => {
                    if (r instanceof HttpResponse) {
                        this.handleResponse(r);
                    }
                    return r;
                })
            );
        } catch (e) {
            console.log(e);
        }
    }

    private addAuthHeader(request: HttpRequest<unknown>): HttpRequest<unknown> {
        try {
            const { url } = request;
            const { method } = request;
            if (!url.endsWith('/api/IsAlive') && method !== 'JSONP') {
                const jwtToken = this.nomWebServicesJson.token;
                const isNonEnpsReq = url.includes('enpscloud.com') || url.includes('usviking.com') || url.includes('api.openai.com');
                if (jwtToken && !isNonEnpsReq) {
                    return request.clone({
                        setHeaders: {
                            Authorization: jwtToken,
                        },
                    });
                }
            }
            return request;
        } catch (e) {
            console.log(e);
        }
    }

    private handleResponse(r: HttpResponse<any>) {
        // const isDiscoverReq = r.url.includes('enpscloud.com') || r.url.includes('usviking.com');
        // if (!isDiscoverReq) {
        try {
            const jwtToken = r.headers.get('Authorization');
            if (jwtToken) {
                this.nomWebServicesJson.token = jwtToken;
            }
            // }
            const newNomTokenId = r.headers.get('X-ENPS-TOKEN');
            if (newNomTokenId && newNomTokenId !== this.nomWebServicesJson.NomTokenId) {
                this.nomWebServicesJson.NomTokenId = newNomTokenId;
                localStorage.setItem('SessionNomTokenId', this.nomWebServicesJson.NomTokenId);
            }
            if (
                r.status >= 200 &&
                r.status < 300 &&
                !(r.url.endsWith('/api/IsAlive') || r.url.includes('/api/SSOSettings') || r.url.includes('/api/SSOConfigSetings') || r.url.includes('config.json'))
            ) {
                this.nomWebServicesJson.noSession = false;
            }
            const version = r.headers.get('jsonversion');
            if (version && version !== environment.pst_version && !environment.production) {
                // TODO: UNCOMMENT AFTER MODAL REWORK
                // const ref = this.modalService.openAlert('New Version', "A newer version is now available. Please click 'OK' to upgrade. You will need to login again.", '')
                // ref.result.then(() => {
                //     Util.clearLocalStorage();
                //     window.location.reload();
                // })
            }
        } catch (e) {
            console.log(e);
        }
    }
}
